import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import SimpleButton from "../components/Buttons/SimpleButton";
import Column from "../components/Column/Column";
import ComposeLogoLink from "../components/Link/ComposeLogoLink";
import Text from "../components/Text/Text";
import { Timeline } from "../components/Timeline/Timeline";
import director_board from "../imgs/director_board_icon.svg";
import youtube_icon from "../imgs/youtube_icon.svg";
import MasterCopy from "../common/models/MasterCopy";

interface IssueLicensePageProps {
  theme: string;
  toggleTheme: any;
}

interface IssueLicenseState {
  song: MasterCopy;
}

const BorderBox = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 20%;
  min-height: 30%;
  padding-inline: 10%;
  border: 0.5px solid #ffffff90;
  border-radius: 20px;
`;

const IssueLicenseContainer = styled.div`
position: relative;
  display: flex;
  flex-wrap: wrap;
  background: #000D30;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  gap: 30px;
  align-items: center;
  justify-content: center;
`;

export const IssueLicensePage = ({
  theme,
  toggleTheme,
}: IssueLicensePageProps) => {
  const timelineEvents = ["Issue License", "Set Subscriber Count Pricing", "Contract Specification and Agreement"];
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as IssueLicenseState;

  const onYoutubeSelect = () => {
    navigate("/subscriber_count_pricing", { state: { timelineEvents: timelineEvents, selectedLicense: "youtube", song: state.song } });
  };

  const onFreelanceSelect = () => {
    navigate("/subscriber_count_pricing", { state: { timelineEvents: timelineEvents, selectedLicense: "freelance", song: state.song } });
  };

  return (
    <> 
      <ComposeLogoLink/>
      <IssueLicenseContainer>
        <Timeline events={timelineEvents} currentEventIndex={0} />

        <BorderBox
        >
          <Column>
            <img src={youtube_icon} />
            <Text style={{textAlign: 'center'}}>Youtube</Text>
            <SimpleButton onClick={onYoutubeSelect}>Select</SimpleButton>
          </Column>
        </BorderBox>

        {/* <BorderBox
        >
          <Column>
            <img src={director_board} />
            <Text>Freelance</Text>
            <SimpleButton onClick={onFreelanceSelect}>Select</SimpleButton>
          </Column>
        </BorderBox> */}
      </IssueLicenseContainer>
      </>
  );
};
